<template>
  <div class="w-full rounded-md border border-neutral-200 bg-white px-6 py-5 shadow-sm hover:shadow-lg hover:border-neutral-300 transition">
    <div class="flex items-center space-x-3">
      <div class="shrink-0">
        <vetster-client-image
          :name="review.author"
          size="md"
          no-margin
        />
      </div>
      <div class="flex-1 min-w-0">
        <div class="focus:outline-none">
          <p class="text-base font-medium text-neutral-900">
            {{ review.author }}
          </p>
          <p class="text-sm text-neutral-500 truncate">
            {{ createdAt }}
          </p>
        </div>
      </div>
    </div>
    <div class="mt-4 leading-6">
      <vetster-read-more
        :cutoff="200"
        :text="review.body"
      />
    </div>
  </div>
</template>

<script>
import VetsterClientImage from '@/components/VetsterClientImage';
import VetsterReadMore from '@/components/VetsterReadMore';
import { monthYearFromISO } from '@/helpers/dateUtils';

export default {
  name: 'VetsterReview',

  components: {
    VetsterClientImage,
    VetsterReadMore,
  },

  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  computed: {
    createdAt() {
      return monthYearFromISO(this.review.created_at);
    },
  },
};
</script>
